import React from 'react'

type Props = {
  errorText: string
  'data-cy-state'?: string
}

export default function EmailInvalid(props: Props) {
  const emainInvalid = React.useRef<HTMLDivElement>(null)

  React.useEffect(() => {
    emainInvalid.current?.focus()
  }, [props.errorText])

  return (
    <div
      ref={emainInvalid}
      className="email-invalid"
      role="alert"
      aria-live="assertive"
      tabIndex={-1}
    >
      <p>{props.errorText}</p>
    </div>
  )
}
